import XLSX from 'xlsx';

/**
 * 导出excel
 * @param {Object} data 表格数据
 * @param {String} fileName 下载文件名，默认 export.xlsx
 */
function ExportExcel(data, fileName) {
	// 创建工作簿
	/* const wb = XLSX.utils.book_new();
	// 创建工作表数据
	const ws = XLSX.utils.json_to_sheet([{
			A1: "数据1",
			B1: "数据2"
		},
		{
			A2: "数据3",
			B2: "数据4"
		}
	]);
	// 将工作表添加到工作簿
	XLSX.utils.book_append_sheet(wb, ws, "Sheet1"); */


	const worksheet = XLSX.utils.json_to_sheet(data);
	const columnWidths = [{
			wch: 20
		}, // 第一列宽度为20
		{
			wch: 20
		}, // 第二列宽度为15
		{
			wch: 10
		}, // 第三列宽度为10
		{
			wch: 15
		}, // 第四列宽度为15
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		},
		{
			wch: 15
		}
	];
	worksheet['!cols'] = columnWidths;
	const wb = {
		Sheets: {
			'data': worksheet
		},
		SheetNames: ['data']
	};


	// 生成Excel的配置项
	const wbout = XLSX.write(wb, {
		bookType: 'xlsx',
		type: 'binary'
	});
	// 创建二进制对象并创建url
	const blob = new Blob([s2ab(wbout)], {
		type: 'application/octet-stream'
	});
	const url = URL.createObjectURL(blob);
	// 创建a标签模拟点击进行下载
	const a = document.createElement('a');
	a.href = url;
	a.download = fileName || 'export.xlsx';
	document.body.appendChild(a);
	a.click();
	// 清除对象URL
	setTimeout(function() {
		URL.revokeObjectURL(url);
		document.body.removeChild(a);
	}, 0);
}

function hello() {
	console.log("Hello World!")
}

/**
 * 字符串转二进制
 */
function s2ab(s) {
	const buf = new ArrayBuffer(s.length);
	const view = new Uint8Array(buf);
	for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}
export default { //注意这里是default
	ExportExcel,
	hello
}